import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
  DelaAcceptAllButton,
  DelaRejectAllButton
} from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  title: {
    margin: theme.spacing(0, 1, 0, 0)
  },
  delaRecommendationButtonsContainer: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap'
  }
}));

const useDelaButtonStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.3),
      padding: theme.spacing(0.3, 1)
    }
  }
}));

const title = <FormattedMessage id="skillInfoCard.skills" />;

const SkillsCardTitle = ({
  editable,
  acceptAllSkillNudges,
  rejectAllSkillNudges,
  hasNudges,
  canEditSkills
}) => {
  const classes = useStyles();
  const delaButtonClasses = useDelaButtonStyles();

  const showActions = editable && hasNudges && canEditSkills;

  if (!showActions) {
    return title;
  }

  return (
    <div className={classes.titleContainer}>
      <div className={classes.title}>{title}</div>
      <div className={classes.delaRecommendationButtonsContainer}>
        <DelaAcceptAllButton
          classes={delaButtonClasses}
          onClick={acceptAllSkillNudges}
          dataQeId="AcceptAllSkillsUserNudges"
        >
          <FormattedMessage id="dela.acceptAll" />
        </DelaAcceptAllButton>
        <DelaRejectAllButton
          classes={delaButtonClasses}
          onClick={rejectAllSkillNudges}
          dataQeId="RejectAllSkillsUserNudges"
        >
          <FormattedMessage id="dela.rejectAll" />
        </DelaRejectAllButton>
      </div>
    </div>
  );
};

SkillsCardTitle.propTypes = {
  editable: PropTypes.bool.isRequired,
  acceptAllSkillNudges: PropTypes.func,
  rejectAllSkillNudges: PropTypes.func,
  hasNudges: PropTypes.bool,
  canEditSkills: PropTypes.bool
};

export default SkillsCardTitle;
